module.exports = __webpack_public_path__ + "img/filter.fe273f79.svg";